import React from 'react';
import PropTypes from 'prop-types';

// Third Party
import { Button } from 'react-bootstrap';
import {
  LOG_IN_HREF,
  LOG_IN_LABEL,
  SIGN_UP_HREF,
  SIGN_UP_LABEL,
} from '../../authLinks';
import styles from './NavBarCTA.module.scss';

export default function NavBarCTA({
  displayUpsellButton,
  displayApplyButton,
  displaySignUpButton,
  displayPostJobButton,
  displaySignUpWithRedirect,
}) {
  const handleApplyButton = () => {
    const element = document.getElementById('jobDetailsPitchSection');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const upsellButton = (
    <Button
      bsStyle="primary"
      className={styles.navButton}
      href={'/pricing/creative'}
    >
      Upgrade to Pro
    </Button>
  );

  const applyButton = (
    <Button
      bsStyle="primary"
      className={styles.navButton}
      onClick={() => handleApplyButton()}
    >
      Apply
    </Button>
  );

  const signUpButton = (
    <span className={styles.guestActions}>
      <a href={LOG_IN_HREF} className={styles.logInLink}>
        {LOG_IN_LABEL}
      </a>
      <Button
        bsStyle="primary"
        className={styles.navButton}
        href={SIGN_UP_HREF}
      >
        {SIGN_UP_LABEL}
      </Button>
    </span>
  );

  const postJobButton = (
    <Button bsStyle="primary" className={styles.navButton} href={'/post-a-job'}>
      Post a Project
    </Button>
  );

  return (
    <>
      {/* The Logic to display any of these is currently handled in the Sticky header  */}
      {displayUpsellButton && upsellButton}
      {displayApplyButton && applyButton}
      {displaySignUpButton && signUpButton}
      {/* The following logic to handle the render of the following buttons will be done in the header,*/}
      {displayPostJobButton && postJobButton}
      {displaySignUpWithRedirect && signUpButtonWithRedirect}
    </>
  );
}

NavBarCTA.propTypes = {
  displayUpsellButton: PropTypes.bool.isRequired,
  displayApplyButton: PropTypes.bool.isRequired,
  displaySignUpButton: PropTypes.bool.isRequired,
  displayPostJobButton: PropTypes.bool.isRequired,
  displaySignUpWithRedirect: PropTypes.bool.isRequired,
};

NavBarCTA.defaultProps = {
  displayUpsellButton: false,
  displayApplyButton: false,
  displaySignUpButton: false,
  displayPostJobButton: false,
  displaySignUpWithRedirect: false,
};
